import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/internal/operators/tap';
import { TokenService } from '../../shared/utils/token.service';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { HttpHeader } from '../constants/app.constant';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private requestedUrl: string;

  constructor(
    private tokenService: TokenService,
    private cacheResolverService: CacheResolverService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.cacheResolverService.get(CacheConstant.OktaAuth)) {
      var temp = this.tokenService.getJWT('token');
        let authReq: any = '';
        if (request.url.toLowerCase().includes('document')) {
          authReq = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${temp}`)
          })
        }
        else{
          authReq = request.clone({
            headers: request.headers.set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${temp}`)
          })
        }
        return next.handle(authReq);
    }
    else {
      this.requestedUrl = request.url;
      const cloneRequest = request.clone({
        setHeaders: this.setAuthTokenHeader(request.headers)
      });

      return next.handle(cloneRequest).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.verifyAuthToken(event);
            }
          }
        )
      );
    }
  }

  private setAuthTokenHeader(headers: HttpHeaders) {
    const requestHeaders = {};
    const token = this.tokenService.get();

    if (token.accessToken) {
      requestHeaders[HttpHeader.Token] = token.accessToken;
    }

    if (headers.keys().length > 0) {
      headers.keys().forEach(key => {
        requestHeaders[key] = headers.get(key);
      });
    }

    return requestHeaders;
  }

  /**
   * Check for updated authorization token for every http response and update in cache.
   * @param response Http Service Response
   */
  private verifyAuthToken(response: HttpResponse<any>) {
    const accessTokenKey = response.headers
      .keys()
      .filter(key => key.toLowerCase() === HttpHeader.Token.toLowerCase())[0];

    if (accessTokenKey) {
      this.tokenService.set(response.headers.get(accessTokenKey));
    }
  }

  // /*********************Private Methods*********************/
}
